import React from 'react'
import Loader from 'ui/Loader/Loader'
import LandingBuilderPage from '../../landingBuilder/main/LandingBuilderPage/LandingBuilderPage'
import { useFillInStore } from '../zustand/fillStore/fillStore'
import useLandingStore from '../zustand/store'

// Одностраничник для просмотра клиентом перед покупкой
function LandingPage() {
	useFillInStore()

	const [dataLoadingStatus, errorMessage, landing, tariffs] = useLandingStore(
		(store) => [
			store.dataLoadingStatus,
			store.errorMessage,
			store.landing,
			store.tariffs,
		]
	)

	if (dataLoadingStatus === 'loading') {
		return <Loader />
	} else if (dataLoadingStatus === 'notPublished') {
		return <p>Одностраничник не опубликован</p>
	} else if (dataLoadingStatus === 'error') {
		if (errorMessage) {
			return <p>{errorMessage}</p>
		}

		return <p>При загрузке данных произошла ошибка</p>
	}

	return <LandingBuilderPage landing={landing} tariffs={tariffs} />
}

export default LandingPage
